import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={
                "https://res.cloudinary.com/dgsjlfsoi/image/upload/v1675869502/shopzoid_m7c4ix.png"
              }
              isBlog={false}
              title="ShopZoid"
              description="The website offers a seamless shopping experience for users and a convenient dashboard for the admin to manage the website.I is built with MERN (MongoDB, Express.js, React.js, and Node.js) stack .
              "
              ghLink="https://github.com/ashwin2003/ecommerce-frontend"
              demoLink="https://63b55f84db91074fff01f53f--bespoke-phoenix-7e4d31.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={
                "https://res.cloudinary.com/dgsjlfsoi/image/upload/v1675869473/mind_mate_buhcw4.png"
              }
              title="Mind Mate"
              description="Mental health is an important aspect of overall health and well-being. It affects how we think, feel, and act, and it can be influenced by various factors, including genetics, environment, and life experiences. Built with NextJs, NodeJs, MongoDB."
              ghLink="https://github.com/ashwin2003/mind-mate-frontend"
              demoLink="https://mind-mate-frontend.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={
                "https://res.cloudinary.com/dgsjlfsoi/image/upload/v1675869466/chat_app_sjctfw.png"
              }
              title="Chat App"
              description="Developed a Full Stack Chat App Project with realtime messaging fuctionality with Socket.IO . Project includes one on one chat as well as group chatting functionality. Built with React, JavaScript, BootStrap, CSS, Socket.io ."
              ghLink="https://github.com/ashwin2003/Chat-Application"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
